
/**
 * Boxes content module
 *
 * @module Map
 * @author EN GARDE
 * @version 1.1
 */var EN = EN || {};

EN.Box = (function ($) {
	'use strict';


	var $enBoxes = $('.en_boxes');
	var $enBox = $('.en-box');
	var $enBoxThumb = $('.en-box__thumb');
	var $enBoxContent = $('.en-box__content');


	var removeBoxActive = function() {
		$enBoxes.removeClass('en-is-expanded');
		$enBox.removeClass('en-has-box-active');
		$enBoxThumb.removeClass('en-is-open');
		$enBoxContent.removeClass('en-is-open').removeClass('en-is-expanded');
		$enBox.removeClass('en-is-open');
	}

	var init = function () {

		$(document).on('classclickadd','.en-box__thumb',function(e){
			if (this !== e.target) {
				return;
			}
			removeBoxActive();

		});
		$(document).on('classclickremove', '.en-box__content', function(e) {
			if (this !== e.target) {
				return;
			}
			removeBoxActive();
		});


		$(window).resize(function(){

			removeBoxActive();
		});
	};
	return {
		init: init
	};

}(jQuery));
